import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const DashboardActivity = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, pages: 1 });

  const load = async (page = 1) => {
    setLoading(true);
    try {
      const res = await api.get('/admin/activity-logs', { params: { page, limit: 30 } });
      setLogs(res.data.data);
      setPagination(res.data.pagination);
    } catch (e) { toast.error('Gagal memuat log'); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const getActionColor = (action) => {
    if (action?.includes('CREATE') || action === 'REGISTER') return 'badge-success';
    if (action?.includes('DELETE')) return 'badge-danger';
    if (action?.includes('UPDATE')) return 'badge-warning';
    return 'badge-info';
  };

  return (
    <div>
      <div className="dashboard-header"><h2>Log Aktivitas</h2><p>Riwayat seluruh aktivitas pengguna di portal NGADHU</p></div>
      {loading ? <div className="loading-spinner"><div className="spinner" /></div> : (
        <div className="table-container">
          <table className="data-table">
            <thead><tr><th>User</th><th>Aksi</th><th>Detail</th><th>Waktu</th></tr></thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={i}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <div className="user-avatar" style={{ width: 28, height: 28, fontSize: '0.65rem' }}>{log.user?.nama?.charAt(0) || '?'}</div>
                      <div><div style={{ fontSize: '0.85rem', fontWeight: 600 }}>{log.user?.nama || 'Unknown'}</div><div style={{ fontSize: '0.7rem', color: 'var(--gray-400)', textTransform: 'capitalize' }}>{log.user?.role}</div></div>
                    </div>
                  </td>
                  <td><span className={`badge ${getActionColor(log.action)}`}>{log.action}</span></td>
                  <td style={{ fontSize: '0.85rem', color: 'var(--gray-600)' }}>{log.details || '-'}</td>
                  <td style={{ fontSize: '0.8rem', color: 'var(--gray-400)', whiteSpace: 'nowrap' }}>{new Date(log.createdAt).toLocaleString('id-ID')}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center', padding: '2rem', color: 'var(--gray-400)' }}>Tidak ada log aktivitas</td></tr>}
            </tbody>
          </table>
        </div>
      )}
      {pagination.pages > 1 && (
        <div className="pagination" style={{ marginTop: '1rem' }}>
          {Array.from({ length: pagination.pages }, (_, i) => i + 1).map(p => (
            <button key={p} className={p === pagination.page ? 'active' : ''} onClick={() => load(p)}>{p}</button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardActivity;
